import styled from "styled-components";

export const WeekExerciseListBox = styled.div`
  gap: 12px;
  width: 100%;
  display: flex;
  overflow: visible;
  position: relative;
  flex-direction: column;
`;

export const WeekExerciseListTit = styled.h3`
  color: ${(props) => props.theme.colors.text4};
  display: flex;
  font-size: 1.8rem;
  font-weight: 600;
  align-items: center;
  justify-content: space-between;
`;

export const WeekExerciseList = styled.ul`
  gap: 8px;
  width: auto;
  display: inline-flex;
  position: relative;
  overflow-x: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
`;
